import styled, { css } from 'styled-components';
import { flexbox, space } from 'styled-system';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: ", ";\n    align-items: ", ";\n    justify-content: ", ";\n\n    ", "\n    ", "\n    ", "\n    ", "\n\n    & > * {\n        margin-right: ", "px;\n    }\n\n    & > *:last-child {\n        margin-right: 0;\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n        & > * {\n            width: 100%;\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n        margin-top: -", "px;\n        & > * {\n            margin-right: ", "px;\n        }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var alignXKeys = ['left', 'center', 'right'];
var alignXValues = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
var alignYKeys = ['top', 'center', 'bottom'];
var alignYValues = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};

var wrap = function wrap(props) {
  return props.wrap && css(_templateObject(), function (_ref) {
    var space = _ref.space;
    return space;
  }, function (_ref2) {
    var space = _ref2.space;
    return space;
  });
};

var stretch = function stretch(props) {
  return props.stretch && css(_templateObject2());
};

var Inline = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return !['alignX', 'alignY', 'space', 'wrap'].includes(prop) && defaultValidatorFn(prop);
  }
}).attrs(function (_ref3) {
  var _ref3$align = _ref3.align,
      align = _ref3$align === void 0 ? '' : _ref3$align,
      alignX = _ref3.alignX,
      alignY = _ref3.alignY,
      space = _ref3.space;
  return {
    alignX: alignX != null ? alignX : align.split(' ')[0],
    alignY: alignY != null ? alignY : align.split(' ')[1],
    space: space != null ? space : 0
  };
})( /*#__PURE__*/_templateObject3(), function (_ref4) {
  var wrap = _ref4.wrap;
  return wrap ? 'wrap' : 'nowrap';
}, function (_ref5) {
  var _ref5$alignY = _ref5.alignY,
      alignY = _ref5$alignY === void 0 ? 'top' : _ref5$alignY;
  return alignYKeys.includes(alignY) ? alignYValues[alignY] : alignY;
}, function (_ref6) {
  var _ref6$alignX = _ref6.alignX,
      alignX = _ref6$alignX === void 0 ? 'left' : _ref6$alignX;
  return alignXKeys.includes(alignX) ? alignXValues[alignX] : alignX;
}, wrap, stretch, flexbox, space, function (_ref7) {
  var space = _ref7.space;
  return space;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n    display: grid;\n    grid-gap: ", "px;\n    align-content: start;\n    justify-items: ", ";\n    box-sizing: border-box;\n    width: 100%;\n\n    ", "\n    ", "\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var alignValues = {
  left: 'start',
  center: 'center',
  right: 'end'
};
var Stack = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
    return !['align', 'space'].includes(prop) && defaultValidatorFn(prop);
  }
}).attrs(function (_ref) {
  var space = _ref.space;
  return {
    space: space != null ? space : 0
  };
})( /*#__PURE__*/_templateObject$1(), function (_ref2) {
  var space = _ref2.space;
  return space;
}, function (_ref3) {
  var stretch = _ref3.stretch,
      _ref3$align = _ref3.align,
      align = _ref3$align === void 0 ? 'left' : _ref3$align;
  return stretch ? 'stretch' : alignValues[align];
}, space, flexbox);
export { Inline, Stack };